import { SET_TOKEN } from '../actions/const';

const initialState = {
  token: null,
  context: null
};

function reducer(state = initialState, action) {

  const nextState = Object.assign({}, state);

  switch (action.type) {
    case SET_TOKEN: {
      nextState.token = action.token;
      nextState.context = action.context;
      return nextState;
    }
    default: {
      return state;
    }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/commons.js